import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const shipmentCategoryParamsSchema = object({
  shipmentCategoryId: stringToNumber()
})
